import { ChatTarget } from "@/domains/chat/constants/chat";
import ChatAttemptMessage from "@/domains/chat/components/chat/messages/ChatAttemptMessage";
import ChatEmoteMessage from "@/domains/chat/components/chat/messages/ChatEmoteMessage";
import ChatErrorMessage from "@/domains/chat/components/chat/messages/ChatErrorMessage";
import ChatFactionMessage from "@/domains/chat/components/chat/messages/ChatFactionMessage.tsx";
import ChatFactionOocMessage from "@/domains/chat/components/chat/messages/ChatFactionOocMessage";
import ChatFamilyMessage from "@/domains/chat/components/chat/messages/ChatFamilyMessage.tsx";
import ChatFamilyOocMessage from "@/domains/chat/components/chat/messages/ChatFamilyOocMessage.tsx";
import ChatNativeMessage from "@/domains/chat/components/chat/messages/ChatNativeMessage";
import ChatSceneMessage from "@/domains/chat/components/chat/messages/ChatSceneMessage";
import ChatShoutMessage from "@/domains/chat/components/chat/messages/ChatShoutMessage.tsx";
import ChatSpeakEmoteMessage from "@/domains/chat/components/chat/messages/ChatSpeakEmoteMessage.tsx";
import ChatSpeakOocMessage from "@/domains/chat/components/chat/messages/ChatSpeakOocMessage.tsx";
import ChatStaffMessage from "@/domains/chat/components/chat/messages/ChatStaffMessage.tsx";
import ChatValidationErrorMessage from "@/domains/chat/components/chat/messages/ChatValidationErrorMessage";
import ChatWhisperMessage from "@/domains/chat/components/chat/messages/ChatWhisperMessage.tsx";
import ChatWorldMessage from "@/domains/chat/components/chat/messages/ChatWorldMessage.tsx";

export const MessageComponent = {
  [ChatTarget.Speaking]: ChatSpeakEmoteMessage,
  [ChatTarget.SpeakingOoc]: ChatSpeakOocMessage,
  [ChatTarget.Shout]: ChatShoutMessage,
  [ChatTarget.Whisper]: ChatWhisperMessage,
  [ChatTarget.Emote]: ChatEmoteMessage,
  [ChatTarget.Error]: ChatErrorMessage,
  [ChatTarget.ValidationError]: ChatValidationErrorMessage,
  [ChatTarget.Native]: ChatNativeMessage,
  [ChatTarget.Attempt]: ChatAttemptMessage,
  [ChatTarget.Scene]: ChatSceneMessage,
  [ChatTarget.SpeakEmote]: ChatSpeakEmoteMessage,
  [ChatTarget.Staff]: ChatStaffMessage,
  [ChatTarget.Faction]: ChatFactionMessage,
  [ChatTarget.FactionOoc]: ChatFactionOocMessage,
  [ChatTarget.Family]: ChatFamilyMessage,
  [ChatTarget.FamilyOoc]: ChatFamilyOocMessage,
  [ChatTarget.World]: ChatWorldMessage,
};
